module.exports = __webpack_public_path__ + "static/media/detail-empretec-arena-mobile.68b942e5.png";